<template>
  <div class="login tw-flex tw-flex-col  tw-items-center p-t-65 tw-relative" v-if="!isActive" :style="hiddenButton?'height:200vh':''">
    <div id="logo" class="m-b-137">
      <img :src="info.brand_info&&info.brand_info.brand_logo" alt="" class="width-64 height-64 tw-rounded-full">
    </div>
    <div id="loginFrom" >
      <input type="text" placeholder="请输入账号" class="tw-block p-b-12 m-b-21" v-model="form.account" @focus="hiddenButton=true"  @blur="hiddenButton=false"> 
      <input type="password" placeholder="请输入密码" class="tw-block p-b-12" v-model="form.password" @focus="hiddenButton=true" @blur="hiddenButton=false">
      <div class="p-t-14 tw-flex tw-justify-end ">
        <van-checkbox v-model="checked" checked-color="#4290FF" shape="square"><span class="tw-text-theme tw-font-medium fz-14">记住密码</span></van-checkbox>
      </div>
      <div id="button" @click="login" class="tw-absolute tw-rounded-full height-44 s_lin_h44 tw-text-center tw-text-white" v-if="!hiddenButton">登陆</div>
    </div>
  </div>
  <div class="login tw-flex tw-flex-col  tw-items-center p-t-65 tw-relative" v-else>
    <div id="loginFrom" class="activeFrom">
      <input type="text" placeholder="请输入激活码" class="tw-block p-b-12 m-b-21  m-t-40" v-model="active_code"  @focus="hiddenButton=true" @blur="hiddenButton=false">
      <div id="button" @click="activeDevice" class="tw-absolute tw-rounded-full height-44 s_lin_h44 tw-text-center tw-text-white" v-if="!hiddenButton">激活</div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from '@vue/reactivity';
import {setStore,getStore,removeStore} from '@/utils/util'
import { onMounted, watch } from '@vue/runtime-core';
import { useRoute, useRouter } from 'vue-router';
import { Toast } from 'vant'
import store from '@/store'
import {pdaActive,getUserInfo,pdaLogin} from '@/api/index'
import {iscode} from '@/utils/app'
import {
  clearActivationPending,
  isActivationPending,
  markActivationPending
} from '@/utils/activation'
export default {
  name: "login",
  setup() {
    const checked = ref(false)
    const form=ref({
      account:"",
      password:""
    })
    const hiddenButton=ref(false)
    const router=useRouter()
    const route=useRoute()
    // 登录
    const login=async ()=>{
        if(checked){ setStore('Account',form.value)}else{removeStore('Account')}
        let result=await pdaLogin(form.value).then(res=>res.data).catch(error=>error)
        console.log(result)
        if(iscode(result,true)){
          setStore('token',result.data.token)
          router.push({path:'/index'})
        }
    }
    const info=computed({get(){return  store.state.user.info}})
    // 激活状态
    const isActive=ref(isActivationPending())
    const active_code=ref('')
    const activeDevice=async ()=>{
      if(!active_code.value){
        Toast.error('请输入激活码')
        return
      }
      let result =await pdaActive(active_code.value,{IMEI:getStore('IMEI'),active_code:active_code.value}).then(res=>res.data).catch(error=>error)
      if(iscode(result,true)){
        clearActivationPending()
        isActive.value=false
        const query = { ...route.query }
        delete query.isAcive
        await router.replace({ path: '/login', query })
        let userInfo=await getUserInfo().then(res=>res.data).catch(error=>error)
        if (userInfo && userInfo.code === 0) {
          store.commit('user/SET_USER_INFO', userInfo.data);
        }
      }
    }
    watch(
      () => route.query.isAcive,
      (isAcive) => {
        if (isAcive) {
          markActivationPending()
          isActive.value=true
        }
      },
      { immediate: true }
    )
    onMounted(()=>{
      if(getStore('Account')){
        form.value=getStore('Account')
        checked.value=true
      }
    })
    return {
      checked,
      form,
      login,
      isActive,
      activeDevice,
      active_code,
      info,
      hiddenButton
    };
  }
};
</script>
<style scoped lang="scss">

.login {
  background-color: #fff;
  font-size: 16px;
  height: 100%;
  #loginFrom {
    input {
      width: 300px;
      border-bottom: 1px solid #d0d0d0;
      font-size: 14px;
      color: #131212;
      font-weight: 600;
      overflow: hidden;
      border-radius: 0;
    }
    input::-webkit-input-placeholder{
      font-size: 14px;
      font-weight: 400;
      color: #D0D0D0;
    }
    input:focus{
      border-bottom: 1px solid #4290FF;
      caret-color:#4290FF
    }
  }
  #button{
    background: linear-gradient(270deg, #68D0FF 0%, #53A1FF 100%);
    bottom: 39px;
    width: 80%;
    left: 50%;
    transform: translateX(-50%);
  }
  .activeFrom{
     input::-webkit-input-placeholder{
      font-size: 16px;
      font-weight: 500;
      color: #000!important;
    }
  }
}
</style>
